import makeApiRequest from './makeApiRequest';

interface RequestBody {
	amount: number;
	billToForename: string;
	billToSurname: string;
}

const getCbsPayoffSignature = () => {
	const postApiRequest = makeApiRequest('POST');

	const getToken = async (apiBase: string, body: RequestBody, fairId: number) => postApiRequest(`${apiBase}/api/cyber-source/signatures/fairs/${fairId}/payoff`, body);

	return [getToken];
};

export default getCbsPayoffSignature;
